module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-blob-1-6e75158a114135040ad89459ffc09c2b.svg";